module.exports = __webpack_public_path__ + "static/media/rasmus-face.80d2389a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/rasmus-face.jpg
// module id = 413
// module chunks = 0